import { Box, Typography } from '@mui/material'
import { IApprovalChange, IApprovalRequest } from '../../definitions/Approval'
import Formatter from '../../helpers/Formatter'
import ApprovalManager from '../../managers/ApprovalManager'
import SmartCard from '../controls/cards/SmartCard'
import { Column, SmartTable } from '../controls/table'

interface P {
    approval: IApprovalRequest
}

const ContractHistory = ({ approval }: P) => {
    const item = approval?.changes?.reverse()
    const columns: Column<IApprovalChange>[] = [
        { id: 'uuid', label: 'id', isPK: true, hidden: true },
        {
            id: 'action',
            label: 'Change',
            customRenderer: (cell, row, item) => <Typography variant='body2'>{approval.changes.length - (approval.changes.indexOf(item) ?? 0)}</Typography>
        },
        {
            id: 'userName',
            label: 'Changed/Approved by',
            customRenderer: cell => (
                <Box display='flex' gap={2} alignItems='center'>
                    <Typography variant='body2'>{cell.value ?? ''}</Typography>
                </Box>

            )
        },
        {
            id: 'status',
            label: 'Approval status',
            customRenderer: cell => ApprovalManager.getStatusChip(cell.value as string)
        },
        {
            id: 'changedAt',
            label: 'Last update',
            customRenderer: cell => <Typography variant='body2'>{Formatter.truncateIsoDate(cell.value as string)}</Typography>
        }

    ]

    return (

        <SmartCard table={true}>
            <SmartTable<IApprovalChange>
                hidePagination
                columns={columns}
                noCollapse
                datasource={{ items: item }}
                toolbar={{
                    columns: true,
                    search: ['status', 'userName', 'changedBy', 'changedAt'],
                    filters: true,
                    export: {
                        fileName: 'Approvals_table'
                    }
                }}
            />
        </SmartCard>
    )
}

export default ContractHistory
